import React, { PropsWithChildren } from 'react';
import { TbX } from 'react-icons/tb';
import { wrap, head, closeButton, contents, foot } from './style';

interface Props {
  title: React.ReactNode;
  footer?: React.ReactNode;
  handleClose: () => void;
  size?: 'small' | 'medium';
}

function Modal({
  children,
  title,
  footer,
  handleClose,
  size = 'medium',
}: PropsWithChildren<Props>) {
  return (
    <div css={wrap(size)} role="dialog" aria-modal="true">
      <div css={head(size)}>
        <p>{title}</p>
        <button
          type="button"
          css={closeButton}
          onClick={handleClose}
          aria-label="닫기"
        >
          <TbX size={22} />
        </button>
      </div>
      <div css={contents(size)}>{children}</div>
      {footer ? (
        footer
      ) : (
        <div css={foot}>
          <button type="button" onClick={handleClose}>
            확인
          </button>
        </div>
      )}
    </div>
  );
}

export default Modal;
